<template>
	<div>
		<el-dialog
			:close-on-click-modal="false" 
			append-to-body
			:visible.sync="visible" 
			title="消息详情" 
			width="880px"
			v-loading="dialogLoading"
			center
		>
			<el-form size="small" :inline="true" label-width="130px" class="detailForm">
				<el-form-item label="消息类型：" prop="messageType">
					<p style="width: 250px;">{{ dict.label.MESSAGE_TYPE[messageProp.messageType] }}</p>
				</el-form-item>
				<el-form-item label="发送时间：" prop="sendTime">
					<p style="width: 250px;">{{ messageProp.sendTime }}</p>
				</el-form-item>
				<el-form-item label="消息内容：" prop="content">
					<div class="contentBox" v-if="messageProp.content">
						<div class="content">
							<span v-html="messageProp.content" style="margin-right: 10px;"></span>
							<span v-if="messageProp.linkUrl" style="display: inline-block;">
								点击<el-button type="text" style="font-size: 14px;line-height: 0;" @click="goView">详情</el-button>查看
							</span>
						</div>
					</div>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="text" @click="visible = false">关闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: "messageDialog",
		dicts: ["MESSAGE_TYPE"],
		props: {
			value: {
				type: Boolean,
				default: false
			},
			messageProp: {
				type: Object,
				requierd: true
			}
		},
		data() {
			return {
				visible: this.value,
				dialogLoading: false,
			}
		},
		watch: {
			value(newVal) {
				this.visible = this.value
			},
			visible(newVal) {
				this.$emit("input", newVal)
			}
		},
		methods: {
			goView() {
				const actualUrl = this.messageProp.linkUrl.split(",").join("/")
				this.$router.push({
					path: actualUrl
				})
				this.visible = false
			},
		},
	}
</script>

<style scoped lang="scss">
	.contentBox {
		width: 650px;
		overflow: auto;
		.content {
			line-height: 20px;
			min-height: 300px;
			border-radius: 4px;
			padding: 15px;
			background-color: rgba(243, 243, 243, 0.6);
			box-shadow: 1px 1px rgba(243, 243, 243, 0.6);
			color: #5a5e66;
		}
	}
</style>